import { ReactElement } from 'react';
import { NEW_NON_EMPLOYEE_KEYS } from 'pages/NewNonEmployee/_const';
import CustomTextField from '../base/CustomTextField';

/**
 * Prompt user for input: phone number extension
 * @returns {ReactElement} textfield prompting for phone number extension
 */
const PhoneNumberExtension = () => {
	return (
		<CustomTextField
			name={NEW_NON_EMPLOYEE_KEYS.PHONE_NUMBER_EXTENSION}
			label='Phone Extension'
		/>
	);
};
export default PhoneNumberExtension;
